<template>
  <div class="mt-20">
   <!-- <Aboutplay /> -->
   <PlayVideo />
  </div>
</template>
<script>
// import Aboutplay from "./components/Aboutplay.vue"
import PlayVideo from "./components/Playvideos.vue"
export default {
  components: {
    // Aboutplay,
    PlayVideo,
  },

};
</script>
